import { pricingService } from '@/api/pricing.service';

import { useQuery } from '@tanstack/vue-query';
import { type MaybeRefOrGetter, toRef } from '@vueuse/core';
import type { RequestAdditionalCostsDto } from '@carvia/ros-client-types';
import { toValue } from 'vue';

export const ADDITIONAL_COSTS_QUERY_KEY = 'additional-costs';

export const useRequestAdditionalCosts = (
  params: MaybeRefOrGetter<RequestAdditionalCostsDto>,
  enabled: MaybeRefOrGetter<boolean> = true,
) => {
  return useQuery({
    queryKey: [
      ADDITIONAL_COSTS_QUERY_KEY,
      () => toValue(params).bookingId,
      () => toValue(params).returnDate,
    ],
    queryFn: () => pricingService.requestAdditionalCosts(toValue(params)),
    enabled: toRef(enabled),
  });
};
